module.exports = __webpack_public_path__ + "static/media/front.b5b5bd44.png";